<script>
  import { 
    Tabulator,
    AccessorModule,
    DownloadModule,
    ExportModule,
    FilterModule,
    FormatModule,
    ResponsiveLayoutModule,
    SortModule,
  } from 'tabulator-tables'
  import { onMount } from 'svelte'

  // 'register' the modules -  http://tabulator.info/docs/6.3
  Tabulator.registerModule([FormatModule, FilterModule, DownloadModule, AccessorModule, ExportModule, ResponsiveLayoutModule, SortModule])

  export let data, columns

  export let filterArray = []
  export const triggerDownload = (filename = undefined) => {
    if(tableRef) {
      if(filename) {
        let regexSymbols = /[\s+)(]/g
        let processedTitle = String(filename).replaceAll(regexSymbols, '-')
        tableRef.download('csv', processedTitle)
      } else {
        tableRef.download('csv', 'data-export.csv')
      }
    }
  }

  let tableComponent
  let tableRef = undefined
  let isTableBuilt = false

  $: {
    if(filterArray && tableRef && isTableBuilt) {
      tableRef.setFilter(filterArray)
    }
  }

  export const addData = (d)=> {
    tableRef.addData(d)
  }

  onMount(()=> {
    tableRef = new Tabulator(tableComponent, {
      data: data,
      reactiveData: true,
      columns: columns,
      layout: 'fitColumns',
      height: '330px',
      maxHeight:'40rem',
      responsiveLayout: true,
      debugInvalidOptions: false,
      width: '100%',
    })

    // http://tabulator.info/docs/6.3/events#table
    tableRef.on("tableBuilt", function(){ 
      isTableBuilt = true
    })

  })
</script>

<svelte:head>
  <link href="https://unpkg.com/tabulator-tables@6.3.0/dist/css/tabulator.min.css" rel="stylesheet">
  <script type="text/javascript" src="https://oss.sheetjs.com/sheetjs/xlsx.full.min.js"></script>
</svelte:head>

<div class="table-wrapper">
  <div class="tabulator" aria-live="polite" bind:this={ tableComponent }></div>
  <span class="hidden tabulator-row tabulator-cell tabulator-header tabulator-col sr-only"></span>
</div>

<style>
  .table-wrapper {
    border-radius: 1rem;
    background-color: #FFF;
    margin: 1rem;
  }

  .tabulator {
    background-color: #FFF;
    font-size: 16px;
    border: none;
    max-height: 100%;
    max-width: 100%;
  }

  .tabulator-header {
    background-color: #FFF;
    border-bottom: none;
    border-top: none;
    min-height: 50px;
  }

  .tabulator-col {
    background-color: #fff;
    border-right: none;
    border-left: none;
  }

  .sr-only {
    display: none;
  }
</style>